export default __webpack_public_path__ + "c599572035ce65a6e07a65f28031c14f.jpg";